import { BUITheme, NoticeProvider } from "@blofin/blofin-ui";
import Cookies from "js-cookie";
import {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useImperativeHandle,
  useState
} from "react";
import { IntlProvider } from "use-intl";
import { updateUserInfo } from "../common/CustomEvent";
import { Languages, LanguagesType } from "../types";
import Header from "./Header";
import { initialState } from "./store/context";
import StoreProvider from "./store/provider";
import { State } from "./store/type";
import { HeaderProps } from "./types";
import { getCookieValue } from "./utils";

const HeaderWrapper: ForwardRefRenderFunction<
  { updateTheme: (theme: BUITheme) => void },
  HeaderProps
> = (
  {
    hideSignUpAndLogIn = false,
    showTheme = false,
    changeTheme,
    position = "sticky",
    baseUrl,
    theme,
    pageTheme,
    themeLock,
    locale,
    hideAcitvityLogo = false,
    customChangeLang,
    isDemoTrading = false,
    hideAllMenus,
    wrapperClass,
    env
  },
  ref
) => {
  useImperativeHandle(ref, () => ({
    updateTheme: (theme: BUITheme) => {
      setState((state) => {
        return {
          ...state,
          theme: theme,
          isSticky: window.scrollY > 0
        };
      });
    }
  }));

  const cookie = (globalThis as any).cookie;
  const role = getCookieValue(cookie, "role");

  const [state, setState] = useState<State>({
    ...initialState,
    hideSignUpAndLogIn: hideSignUpAndLogIn,
    showTheme: showTheme,
    changeTheme: changeTheme,
    position: position,
    theme: position === "sticky" ? (theme ? theme : "dark") : theme ? theme : "light",
    pageTheme: pageTheme,
    baseUrl: baseUrl || "",
    defaultTheme: theme,
    themeLock: themeLock,
    locale: locale as any,
    hideAcitvityLogo: hideAcitvityLogo,
    isDemoTrading: isDemoTrading,
    hideAllMenus: hideAllMenus,
    env: env,
    copyTradeUserInfo: {
      role: role ? Number(role) : 0,
      uid: 0,
      nick_name: "",
      profile: "",
      apply_state: "NON_APPLY"
    },
    userAccountType:
      Cookies.get("Global-AccountType") || getCookieValue(cookie, "Global-AccountType"),
    userViewType:
      Cookies.get("Global-UserViewType") || getCookieValue(cookie, "Global-UserViewType")
  });

  useEffect(() => {
    const existingUserInfo = window.userInfo;
    const existingCopyTradeUserInfo = window.copyTradeUserInfo;

    Object.defineProperty(window, "userInfo", {
      configurable: true,
      enumerable: true,
      get: function () {
        return this._userInfo || null;
      },
      set: function (value) {
        this._userInfo = value;
        updateUserInfo(value);
        setState((prevState) => ({
          ...prevState,
          userInfo: value,
          isLogin: value?.uid ? true : false,
          isSticky: window.scrollY > 0
        }));
      }
    });

    Object.defineProperty(window, "copyTradeUserInfo", {
      configurable: true,
      enumerable: true,
      get: function () {
        return this._copyTradeUserInfo || null;
      },
      set: function (value) {
        this._copyTradeUserInfo = value;
        setState((prevState) => ({
          ...prevState,
          copyTradeUserInfo: value
        }));
      }
    });

    if (existingUserInfo) {
      window.userInfo = existingUserInfo;
    }
    if (existingCopyTradeUserInfo) {
      window.copyTradeUserInfo = existingCopyTradeUserInfo;
    }

    return () => {
      Object.defineProperty(window, "userInfo", {
        configurable: true,
        enumerable: true,
        value: null,
        writable: true
      });
      Object.defineProperty(window, "copyTradeUserInfo", {
        configurable: true,
        enumerable: true,
        value: null,
        writable: true
      });
    };
  }, []);

  // 会触发更新
  useEffect(() => {
    const locale = window?.next?.router?.state?.locale || "en";

    const isDemoTrading = Cookies.get("Global-UserViewType") === "demo-trading";
    setState((state) => ({
      ...state,
      theme: position === "sticky" ? (theme ? theme : "dark") : theme ? theme : "light",
      locale: locale as LanguagesType,
      localeLink: "/" + locale,
      isDemoTrading: isDemoTrading,
      isSticky: window.scrollY > 0
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return (
    <NoticeProvider>
      <StoreProvider value={state}>
        <IntlProvider locale={state.locale} messages={Languages[state.locale as LanguagesType]}>
          <Header customChangeLang={customChangeLang} wrapperClass={wrapperClass} />
        </IntlProvider>
      </StoreProvider>
    </NoticeProvider>
  );
};

export default forwardRef(HeaderWrapper);
